import { render, staticRenderFns } from "./drawerExplanation.component.vue?vue&type=template&id=41b00c37&scoped=true"
import script from "./drawerExplanation.component.vue?vue&type=script&lang=js"
export * from "./drawerExplanation.component.vue?vue&type=script&lang=js"
import style0 from "./drawerExplanation.component.vue?vue&type=style&index=0&id=41b00c37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b00c37",
  null
  
)

export default component.exports